import { render } from "./3.Austria.vue?vue&type=template&id=8702a4fc&scoped=true"
import script from "./3.Austria.vue?vue&type=script&lang=js"
export * from "./3.Austria.vue?vue&type=script&lang=js"

import "./3.Austria.vue?vue&type=style&index=0&id=8702a4fc&lang=css"
import "./3.Austria.vue?vue&type=style&index=1&id=8702a4fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8702a4fc"]])

export default __exports__